// Small dropdown anchored to the Header menu button.
// Items: Weight · History · Settings · Help.

type Item = { label: string; onClick: () => void; danger?: boolean };

type Props = {
  open: boolean;
  onClose: () => void;
  items: Item[];
};

export function MenuDropdown({ open, onClose, items }: Props) {
  if (!open) return null;
  return (
    <div style={styles.backdrop} onClick={onClose}>
      <div style={styles.menu} onClick={(e) => e.stopPropagation()}>
        {items.map((it, i) => (
          <button
            key={it.label}
            style={{
              ...styles.item,
              borderBottom: i === items.length - 1 ? "0" : "1px solid var(--bh-divider)",
              color: it.danger ? "var(--bh-attn)" : "var(--bh-ink)",
            }}
            onClick={() => {
              it.onClick();
              onClose();
            }}
          >
            {it.label}
          </button>
        ))}
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  backdrop: {
    position: "fixed",
    inset: 0,
    background: "transparent",
    zIndex: 60,
  },
  menu: {
    position: "absolute",
    top: 56,
    right: 14,
    minWidth: 180,
    background: "var(--bh-surface-2)",
    border: "1px solid var(--bh-divider)",
    borderRadius: 14,
    overflow: "hidden",
    boxShadow: "0 12px 36px oklch(0 0 0 / 0.4)",
  },
  item: {
    width: "100%",
    appearance: "none",
    background: "transparent",
    border: "none",
    padding: "14px 18px",
    textAlign: "left",
    fontSize: 16,
    cursor: "pointer",
    fontFamily: "inherit",
  },
};
